<template>
    <div v-show="can.create.zone">
        <button-primary @click="open">
            <template slot="icon"><i class="fa fa-plus"></i></template> Neue Zone
        </button-primary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>
                    Neue Zone hinzufügen
                </template>

                <input-text v-model="name" class="mb-4">
                    Zone
                </input-text>

                <div class="grid grid-cols-2 gap-4">
                <div class="mb-8" v-show="availableRooms.length > 0">
                    Räume in der Zone:
                    <div v-for="u in availableRooms">
                        <label>
                            <input type="checkbox" :value="u.id" v-model="checkedRooms">
                            {{ u.name }}
                        </label>
                    </div>
                </div>

                <div class="mb-8" v-show="availableBookables.length > 0">
                    Bookables in der Zone:
                    <div v-for="u in availableBookables">
                        <label>
                            <input type="checkbox" :value="u.id" v-model="checkedBookables">
                            {{ u.name }} {{ u.bookable_category? "("+u.bookable_category.name+")": "" }}
                        </label>
                    </div>
                </div>
            </div>
                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="create"><template slot="icon"><i class="fa fa-plus"></i></template> Zone hinzufügen</button-primary>
                </div>

                <loading v-show="loading"></loading>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import Modal from "./Modal";
import Loading from "./UI/Loading";

export default {
    name: "ZoneCreate",

    components: {Loading, Modal, InputText, ButtonPrimary},

    props: {
        floor: {
            type: Object,
            default: null,
        },
    },

    data: () => ({
        loading: false,
        showModal: false,
        name: '',
        checkedRooms: [],
        availableRooms: [],
        checkedBookables: [],
        availableBookables: [],
        
    }),

    inject: ['can'],

    methods: {
        open() {
            this.showModal = true;
            this.load();
        },
        async load() {
            this.loading = true;
            let rooms = await this.$http.get('/admin/rooms')
            let bookables = await this.$http.get('/admin/bookables')
            this.loading = false;
            this.availableRooms = rooms.data.data;
            this.availableBookables = bookables.data.data;
        },
        create() {
            this.loading = true;
            this.$http.post('/admin/zones', {
                name: this.name,
                rooms: this.checkedRooms,
                bookables: this.checkedBookables,
                floor_id: this.floor ? this.floor.id : null,
            }).then(() => {
                this.loading = false;
                this.$emit('created');
                this.showModal = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
